import {NgModule} from '@angular/core';
import {WizButton} from './wiz-button/wiz-button';
import {CommonModule} from '@angular/common';

import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {WizLabelModule} from '../wiz-label/wiz-label.module';
import {WizStylingDirectiveModule} from '../../../directives/styling/wiz-styling-directives.module';
import { WizImageModule } from '../wiz-image/wiz-image.module';
import { WizLayoutModule } from '../../layouts/wiz-layout.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { WizToggle } from './wiz-toggle/wiz-toggle';
import { MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import { WizRadioButton } from './wiz-radio-button/wiz-radio-button';
import { WizRadioGroup } from './wiz-radio-group/wiz-radio-group';
import { WizCheckbox } from './wiz-checkbox/wiz-checkbox';
import { FormsModule } from '@angular/forms';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { WizIcon } from '../wiz-icon/wiz-icon';
import { WizIconModule } from '../wiz-icon/wiz-icon.module';
import { WizBehaviorDirectiveModule } from '../../../directives/behavior/wiz-behavior-directives.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [WizButton, WizToggle, WizRadioButton, WizRadioGroup, WizCheckbox],
  imports: [
    CommonModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    WizImageModule,
    WizLabelModule,
    WizStylingDirectiveModule,
    BrowserAnimationsModule,
    WizLayoutModule,
    FormsModule,
    WizIconModule,
    WizBehaviorDirectiveModule
  ],
  providers: [
    {provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: {disabled: true}}
  ],
  exports: [WizButton, WizToggle, WizRadioButton, WizRadioGroup, WizCheckbox, WizIcon]
})
export class WizButtonModule { }

